export const normalizeCodeValue = (value) => {
    if (value === null || value === undefined) return "";
    const raw = typeof value === "number" ? String(value) : String(value || "");
    const compact = raw.trim().replace(/\s+/g, "");
    if (!compact) return "";
    if (/^\d+$/.test(compact)) {
        const stripped = compact.replace(/^0+/, "");
        return stripped.length ? stripped : "0";
    }
    return compact;
};